angular.module('picmonic-common').component('testimonialScroller', {
  templateUrl: '/templates/common/components/testimonial-scroller/testimonial-scroller.html',
  bindings: {
    marketId: '<',
  },
  controller: [
    '$state',
    '$interval',
    'TestimonialsResource',
    function ($state, $interval, TestimonialsResource) {
      // Hack to prevent angular loading and evaluating this page, then the router loading and evaluating the page a second time
      if ($state.current.name === '' && window.location.pathname === '/') {
        return;
      }

      var ctrl = this;
      ctrl.selectedOverlay = 0;
      ctrl.search = {
        per_page: 5,
        testimonial_type: 'Text',
      };

      if (ctrl.marketId) {
        ctrl.search.market_id = ctrl.marketId;
      }

      ctrl.testimonials = TestimonialsResource.get(ctrl.search);

      var interval = $interval(function () {
        ctrl.scrollFeatures(1);
      }, 30000);

      ctrl.$onDestroy = function () {
        $interval.cancel(interval);
      };

      ctrl.scrollFeatures = function (scroll) {
        ctrl.selectedOverlay =
          (ctrl.selectedOverlay + scroll + ctrl.testimonials.testimonials.length) %
          ctrl.testimonials.testimonials.length;
      };
    },
  ],
});
